import { ConfigType } from '../types'
import { ProvisionsTotalResults } from '../types/totals'

export const parseProvisionsTotalsResults = (data: ProvisionsTotalResults) => {
  // Extract totals grouped by config_type
  const totals = data.data_by_config_type.map(configTypeData => ({
    config_type: configTypeData.config_type,
    data: configTypeData.data
  }))

  const totalsByConfigType = totals.reduce(
    (acc, curr) => {
      if (!acc[curr.config_type]) {
        acc[curr.config_type] = []
      }
      acc[curr.config_type].push(...curr.data)
      return acc
    },
    {} as Record<ConfigType, ProvisionsTotalResults['data_by_config_type'][number]['data']>
  )

  // Extract detailed data grouped by config_type
  const detailed = data.data_by_config_type.map(configTypeData => ({
    config_type: configTypeData.config_type,
    data_details: configTypeData.data_details
  }))

  const detailedByConfigType = detailed.reduce(
    (acc, curr) => {
      if (!acc[curr.config_type]) {
        acc[curr.config_type] = []
      }
      acc[curr.config_type].push(...curr.data_details)
      return acc
    },
    {} as Record<ConfigType, ProvisionsTotalResults['data_by_config_type'][number]['data_details']>
  )

  return {
    ...data,
    totals: totalsByConfigType,
    detailed: detailedByConfigType
  }
}

type ParsedProvisionsTotalsResults = ReturnType<typeof parseProvisionsTotalsResults>

export type ProvisionsTotalParsed = ParsedProvisionsTotalsResults['totals']
export type ProvisionsDetailedParsed = ParsedProvisionsTotalsResults['detailed']
